import {blue} from '@material-ui/core/colors';

export const PRIMARY_COLOR = blue;
export const TRANSITIONS_TIME = 400;
